import { Alert as BootstrapAlert } from "react-bootstrap";
import { useAlert } from "../../contexts/AlertContext";
import './Alert.scss';

export default function Alert(){

	const { alert, handleSetAlert } = useAlert();

	let time: ReturnType<typeof setTimeout>;

	if(alert?.visible === true) {
		time = setTimeout(() => {
			handleCloseAlert();
		}, alert?.timeout)
	}

	function handleCloseAlert() {
		window.clearTimeout(time);
		handleSetAlert({
			visible: false,
			variant: "",
			message: "",
			timeout: 0,
		});
	}

	return(
		<>
			{alert?.visible && <div className="div-alert">
				<div className="div-alert-child">
					<BootstrapAlert className="alert-component text-center" onClick={() => handleCloseAlert()} variant={alert.variant}>{alert.message}</BootstrapAlert>
				</div>
			</div>}
		</>
	)
}
